@if (!isLoading) {
  <div class="confirm-dialog-container" data-cy="ar-payment-cancel">
    <div class="message-header" data-cy="ar-payment-cancel-header">
      <h5 data-cy="ar-payment-cancel-message">Payment has not been distributed. By canceling, the system will create a {{ this.data.paymentAmount | currency }} credit in the ledger.
        <div style="padding-top: 20px; padding-bottom: 20px" data-cy="ar-payment-cancel-question">
          Would you like to continue with canceling?
        </div>
      </h5>
    </div>
    <div class="action-container-upper" data-cy="ar-payment-cancel-actions">
      <button mat-raised-button color="primary" style="width: 250px;" (click)="cancel()" class="action-button" data-cy="ar-payment-cancel-continue-btn">No, I'll continue with distribution.</button>
      <button mat-raised-button color="warn" style="width: 250px;" (click)="createCredit()" data-cy="ar-payment-cancel-create-credit-btn">Yes, create a {{ this.data.paymentAmount | currency }} credit</button>
    </div>
  </div>
}

@if (isLoading) {
  <div class="spinner-container" data-cy="ar-payment-cancel-spinner-container">
    <mat-spinner data-cy="ar-payment-cancel-spinner"></mat-spinner>
  </div>
}

